import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isValidJSON } from '../utils';
export interface User {
    username: string;
    userType: string;
    projects: boolean;
    privileges: Array<string>;
    roles: Array<string>;
}
export interface AuthState {
    [x: string]: any;
    authUser: User | null;
    authToken: string | null;
    authProject: any | null;
    loading: boolean | null;
}

const userFromLocalStorage = localStorage.getItem('authUser');
const projectFromLocalStorage = localStorage.getItem('authProject');

const initialState: AuthState = {
    authUser: userFromLocalStorage && isValidJSON(userFromLocalStorage) ? JSON.parse(userFromLocalStorage) : null,
    authToken: localStorage.getItem('authToken') || null,
    authProject: projectFromLocalStorage && isValidJSON(projectFromLocalStorage) ? JSON.parse(projectFromLocalStorage) : null,
    loading: false,
};

const authReducer = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthUser: (state, action: PayloadAction<any>) => {
            const { username, userType, projects, privileges, roles, token } = action.payload;
            state.authUser = {
                username,
                userType,
                projects,
                privileges,
                roles,
            };
            state.authToken = token;
            localStorage.setItem('authToken', token);
            localStorage.setItem('authUser', JSON.stringify(state.authUser));
        },
        setAuthProject: (state, action: PayloadAction<any>) => {
            state.authProject = action.payload;
            localStorage.setItem('authProject', JSON.stringify(action.payload));
        },
        showLoading: (state) => {
            state.loading = true;
        },
        hideLoading: (state) => {
            state.loading = false;
        },
        logOut: (state) => {
            state.authUser = null;
            state.authToken = null;
            state.authProject = null;
            state.loading = false;
            localStorage.removeItem('authToken');
            localStorage.removeItem('authUser');
            localStorage.removeItem('authProject');
        }
    },
});

export const { setAuthUser, setAuthProject, showLoading, hideLoading, logOut } = authReducer.actions;
export default authReducer.reducer;